export const ACTION_REMOVE_BALANCE_CART = '/OsimCart/RemoveBalanceCartLines';